module.exports = __webpack_public_path__ + "static/pharmacy-benefits-a8161ff8482bde1d1565f6465245847b.png";